import { getFollowerListQueryOptions, getFollowingListQueryOptions } from '@/utils/fetchers/user'
import { prepareToRefetchListQuery } from '@/utils/list'
import { useInfiniteQuery } from '@tanstack/react-query'
import { flatMap, map } from 'lodash-es'
import { type HTMLAttributes, useCallback, useMemo } from 'react'
import UserList from './UserList'

export interface LoadableUserListProps extends HTMLAttributes<HTMLDivElement> {
	/**
	 * username
	 */
	username: string

	type: 'following' | 'follower'
}

export default function LoadableUserList({ username, type, ...props }: LoadableUserListProps) {
	const queryOptions = useMemo(
		() =>
			type === 'following'
				? getFollowingListQueryOptions(username)
				: getFollowerListQueryOptions(username),
		[username, type]
	)
	const { data, fetchNextPage, refetch } = useInfiniteQuery(queryOptions)

	const refresh = useCallback(() => {
		prepareToRefetchListQuery(queryOptions.queryKey)
		return refetch()
	}, [refetch, queryOptions.queryKey])

	const userNames = useMemo(
		() =>
			map(
				flatMap(data?.pages, (page) => page.data),
				'username'
			),
		[data]
	)

	return <UserList data={userNames} onLoadMore={fetchNextPage} {...props} />
}
